import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DeclensionWordModule } from '@shared/pipes/declension-word/declension-word.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MultiSelectModule } from '@shared/components/multi-select/multi-select.module';
import { ButtonIconModule } from '@impairedShared/button-icon/button-icon.module';
import { ImpairedPaginationModule } from '@impairedShared/impaired-pagination/impaired-pagination.module';
import { ImpairedIconModule } from '@impairedShared/impaired-icon/impaired-icon.module';
import { MainComponent } from './components/main/main.component';
import { RoutingModule } from './routing.module';
import { DataTableComponent } from './components/data-table/data-table.component';
import { FilterTableComponent } from './components/filter-table/filter-table.component';
import { FilterTableDialogComponent } from './components/filter-table-dialog/filter-table-dialog.component';
import { DownloadButtonModule } from '../../../data/shared/components/download-button/download-button.module';

@NgModule({
  declarations: [MainComponent, DataTableComponent, FilterTableComponent, FilterTableDialogComponent],
  imports: [
    CommonModule,
    RoutingModule,
    TranslateModule,
    DeclensionWordModule,
    ButtonIconModule,
    NgLetModule,
    ImpairedPaginationModule,
    OverlayModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    ImpairedIconModule,
    MultiSelectModule,
    DownloadButtonModule
  ]
})
export class DataModule {}
